import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useRef } from 'react';
import { Transition } from 'react-transition-group';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { ChatModal } from '@/components/ChatModal/ChatModal';
import { ErrorPage } from '@/components/ErrorPage/ErrorPage';
import { Header } from '@/components/Header/Header';
import { WelcomeFields } from '@/components/WelcomeFields/WelcomeFields';
import { MAX_TYPING_INDICATOR_MS } from '@/config/constants';
import { isMfaSelector, widgetAlignmentSelector, widgetPositionSelector, } from '@/state/config';
import { composeSelector, composeState, errorSessionSelector, isMobileState, chatEventCountSelector, showWelcomeFormSelector, isWidgetOpenState, } from '@/state/session';
import { isLoadingSelector } from '@/state/socket';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import { defaultStyle, transitionStyles } from './animation';
import { Chat } from './Chat';
import styles from './ChatContainer.module.scss';
export const ChatContainer = () => {
    const timerRef = useRef();
    const widgetAlignment = useRecoilValue(widgetAlignmentSelector);
    const setCompose = useSetRecoilState(composeState);
    const compose = useRecoilValue(composeSelector);
    const widgetPosition = useRecoilValue(widgetPositionSelector);
    const isOpen = useRecoilValue(isWidgetOpenState);
    const isMobile = useRecoilValue(isMobileState);
    const error = useRecoilValue(errorSessionSelector);
    const chatEventsCount = useRecoilValue(chatEventCountSelector);
    const showWelcomeForm = useRecoilValue(showWelcomeFormSelector);
    const isMfa = useRecoilValue(isMfaSelector);
    const isLoading = useRecoilValue(isLoadingSelector);
    // Disable compose after 10 seconds of innactivity(MAX_TYPING_INDICATOR_MS)
    useEffect(() => {
        if (!!compose && chatEventsCount) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = window.setTimeout(() => {
                setCompose(null);
            }, MAX_TYPING_INDICATOR_MS);
        }
        else {
            clearTimeout(timerRef.current);
        }
    }, [chatEventsCount, compose, setCompose]);
    return (_jsx(Transition, { in: isOpen, timeout: 300, children: (state) => {
            const containerStyles = Object.assign(Object.assign({}, defaultStyle), transitionStyles[state]);
            return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cn('chatContainer', styles.container, styles[widgetPosition], {
                            [styles.hideInput]: showWelcomeForm || error,
                            [styles.isMobile]: isMobile,
                            [styles.isPositionLeft]: widgetAlignment === 'left',
                        }), style: containerStyles, children: [_jsx(Header, {}), isMfa && (_jsx("img", { className: styles.espaImage, alt: "Espa", src: `../../public/espa.png` })), error && _jsx(ErrorPage, { error: error }), !error && !isLoading && showWelcomeForm && _jsx(WelcomeFields, {}), !error && !isLoading && !showWelcomeForm && _jsx(Chat, {}), !error && isLoading && _jsx(LoadingPage, {})] }), _jsx(ChatModal, {})] }));
        } }));
};
